var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hard-competences"},[_c('div',{staticClass:"grid"},_vm._l((_vm.getCompetenceKnowledge),function(item,index){return _c('div',{key:index,staticClass:"line"})}),0),_vm._l((_vm.competences),function(item,index){return _c('div',{key:index,staticClass:"competence"},[_c('HardCompetenceItem',{attrs:{"competence":item}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }